import { createFileRoute } from "@tanstack/react-router";
import { HelpDocsPage } from "@client/components/settings/help-docs/help-docs-page";

export const Route = createFileRoute("/_app/settings/help-docs")({
  component: HelpDocsPage,
});
